<template>
  <v-app-bar id="toolbar" :height="desktopTopBarHeight" class="background-top-bar-background">
    <div class="d-flex pa-0 background-top-bar-background color-top-bar-text">
      <app-grid hide-default-secondary>
        <template #left>
          <div class="top-bar-area d-flex align-center fill-height">
            <the-button v-if="useLinkForAppLogo" :to="{ name: $routes.ROOT }" icon class="mr-2 ma-0 logo-button">
              <app-logo />
            </the-button>
            <app-logo v-else class="mr-2" />
            <h1 class="title-container">
              <portal-target name="header-desktop-middle">
                {{ configuration.appTitle }}
              </portal-target>
            </h1>
          </div>
        </template>
        <template #content>
          <div class="top-bar-area d-flex align-center">
            <search-field
              v-if="showSearchPlaceholder"
              is-placeholder
              class="search-field ma-auto"
              @click.native="redirectToSearch"
              @keydown.native.enter="redirectToSearch"
            />
            <portal-target v-else name="header-desktop-middle-right" />
          </div>
        </template>
        <template #content-secondary>
          <portal-target name="header-desktop-right">
            <nav-buttons :show-desktop-nav-buttons="showNavButtons" />
          </portal-target>
        </template>
      </app-grid>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useUserSessionStore } from "@/store/userSession.js"
import { useConfigurationStore } from "@/store/configuration.js"

import AppGrid from "@/components/AppGrid.vue"
import NavButtons from "@/components/navs/NavButtons.vue"
import SearchField from "@/components/navs/SearchField.vue"

import { DESKTOP_TOP_BAR_HEIGHT } from "@/constants/barHeights.js"

export default {
  components: {
    AppGrid,
    NavButtons,
    SearchField
  },
  data() {
    return {
      desktopTopBarHeight: DESKTOP_TOP_BAR_HEIGHT
    }
  },
  computed: {
    ...mapState(useUserSessionStore, ["isLoggedIn", "walkthroughCompleted"]),
    ...mapState(useAppStateStore, ["onboardingModeOrRedirection", "walkthroughSkipped"]),
    ...mapState(useConfigurationStore, ["configuration"]),
    showSearchPlaceholder() {
      return (
        this.$route.name !== this.$routes.SEARCH &&
        this.$route.name !== this.$routes.MEMBER_DIRECTORY &&
        this.$route.name !== this.$routes.WALKTHROUGH &&
        this.isLoggedIn &&
        !this.onboardingModeOrRedirection
      )
    },
    showNavButtons() {
      return !this.onboardingModeOrRedirection && this.$route.name !== this.$routes.WALKTHROUGH
    },
    useLinkForAppLogo() {
      return this.$route.name !== this.$routes.WALKTHROUGH || this.walkthroughCompleted || this.walkthroughSkipped
    }
  },
  methods: {
    redirectToSearch() {
      this.$eventBus.$emit("reset-search")
      this.$router.push({ name: this.$routes.SEARCH })
    }
  }
}
</script>

<style lang="scss" scoped>
#toolbar {
  text-align: left;
  z-index: var(--z-index-headers);
  box-shadow: var(--shadow-2) !important;

  :deep(.v-toolbar__content) {
    justify-content: center;
    z-index: var(--z-index-elevated);
    position: relative;
    //inbox menu
    overflow: visible;

    .logo-button {
      width: auto;
    }

    .v-btn {
      &:not(.v-btn--size-small) {
        height: 40px;
        min-width: 40px;
      }
    }
  }

  :deep(.v-toolbar__content .v-toolbar__content) {
    max-width: 1728px;
    padding: 0 48px;
    margin: 0 auto;
  }

  :deep(.v-toolbar__content) {
    padding: 0;
  }

  .v-toolbar__content .layout {
    z-index: var(--z-index-base);
  }

  .title-container {
    font-size: var(--font-size-title-small);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }

  .logo-button {
    opacity: 1 !important;
  }
}

:deep(.left-column),
:deep(.content),
:deep(.content-secondary) {
  padding: 0 !important;
}

:deep(.content-secondary) {
  overflow-y: visible !important;
}

.top-bar-area {
  height: var(--desktop-top-bar-height);
}
</style>
